import Vue from "vue";
import { loadLazyImages } from "../../../../utilities/globalUtilities";
import { badgeTemplate, productPriceTemplate, productSeparator, productImageTemplate, productDetailsTemplate } from "./templatesHelper";

/**
 * Defines the template for the product item for the modal
 */
const productTemplate = Vue.component("product-item-carousel", {
    template : `
        <div>
            <div :class="cssClass">
                <div class="product-tile-carousel pd-tile-wrap ct-alternative-product-tile-carousel-product">
                    <div class="product-tile ct-product-tile"
                        :data-alt-pid="item.id"
                        :data-delay-time="item.confirmationDelayTime"
                        :data-in-cart-msg="resources.inCartLabel"
                        :data-one-product-added="resources.inCartOneProduct"
                        :data-remove-from-cart-msg="resources.removeFromCartLabel"
                        :data-stay-open="resources.confirmationStayOpen"
                    >
                        <div class="ct-inner-tile-wrap row no-gutters align-content-start">
                            <product-badge :badgeInfo="item.badgeInfo" :brandID="item.productBrandID" v-if="item.badgeInfo" />
                            <product-image :item="item" :resources="resources" />
                            <div class="ct-tile-body col col-sm-auto">
                                <product-details :item="item" />
                            </div>
                            <div class="ct-tile-bottom row align-items-end">
                                <product-price :item="item" />
                                <product-add-to-cart-button :resources="resources" :item="item" :origID="origID" :cartIcon="cartIcon" v-if="!!showAddToCartButton" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
    props: ["resources", "icon", "item", "cssClass", "origID", "showAddToCartButton", "cartIcon", "showSeparator"],
    mounted() {
        loadLazyImages(`.ct-alternative-product-tile-carousel-product [data-alt-pid="${this.item.id}"]`);
    },
    components: {
        badgeTemplate,
        productPriceTemplate,
        productSeparator,
        productImageTemplate,
        productDetailsTemplate
    }
});

export { productTemplate };
